import { render } from "./EmailChoice.vue?vue&type=template&id=7f64d6e0&scoped=true&ts=true"
import script from "./EmailChoice.vue?vue&type=script&lang=ts"
export * from "./EmailChoice.vue?vue&type=script&lang=ts"

import _style_0 from "./EmailChoice.vue?vue&type=style&index=0&id=7f64d6e0&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-7f64d6e0"]])

export default __exports__